import { request } from '@/services/http/client';
import type { BackendRouteItem } from '@/types/route';

// 后端动态路由是菜单、页面分发、权限过滤的唯一数据源。
export const getRouteTreeRequest = async () =>
  request<BackendRouteItem[]>({
    url: '/api/v1/system/menus/app-build',
    method: 'get',
  });
